const producers = [
    {siret: '84264658000022', name: 'LearnyLib'},
    {siret: '79500130400018', name: 'Biotech Dental'},
    {siret: '49198279900034', name: 'Académie du Sourire'},
    {siret: '51146662500015', name: 'CISCO'},
];

export const defaultProducer = siret =>
    producers.find(p => p.siret === siret?.toString())?.siret || producers[0].siret;

export const hasKinds = owner => ['all', producers[0].siret].includes(owner);

export default producers;
